import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sales-order-line-items-reserve-inventory-dialog',
  templateUrl: './sales-order-line-items-reserve-inventory-dialog.component.html',
  styleUrls: ['./sales-order-line-items-reserve-inventory-dialog.component.scss']
})
export class SalesOrderLineItemsReserveInventoryDialogComponent implements OnInit {

  // activated tab
  activeTab = 'warehouse';

  // data
  pmInv = null;
  productModelId = null;
  soItemId = null;
  soItem = null;
  salesOrder = "SalesOrder";

  // endpoints
  private modelQtyEp = `${this.apiSvc.endpoints.catalog}/api/InventoryLookup/quantity`;

  constructor(
    public dialogRef: MatDialogRef<SalesOrderLineItemsReserveInventoryDialogComponent>,
    private apiSvc: ApiService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

    if (this.data.soItem) {
      this.soItem = this.data.soItem;
    }

    if (this.data['soItemId']) {
      this.soItemId = this.data['soItemId'];
    }

    if (this.data['productModelId']) {
      this.productModelId = this.data['productModelId'];
      this.getModelQtys();
    }

  }

  /**
   * Get product model quantities
   */
  getModelQtys(): void {

    this.apiSvc.get(`${this.modelQtyEp}/${this.productModelId}`)
      .subscribe((res) => {
        this.pmInv = res;
      });

  }

  /**
   * Handle reserve event
   */
  onReserve(): void {

    this.dialogRef.close({
      confirm: true
    });

  }

  /**
   * Handle cancel event
   */
  onCancel(): void {
    this.dialogRef.close({confirm: false});
  }

  /**
   * Change tab
   * @param tab - tab key
   */
  changeTab(tab: string): void {
    this.activeTab = tab;
  }


}
